import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PageLayout } from "../components/PageLayout";
import { adminApi, api } from "../lib/api";

export function HomePage() {
  const shopQuery = useQuery({ queryKey: ["shop"], queryFn: api.shop });
  const ownerQuery = useQuery({
    queryKey: ["adminMe"],
    queryFn: adminApi.me,
    retry: false, // 403 はリトライ不要
  });
  const shop = shopQuery.data?.shop;
  const businessHours = formatBusinessHours(shopQuery.data?.settings.businessHours);
  const isOwner = ownerQuery.data?.role === "owner";

  return (
    <PageLayout title={shop?.name ?? "炭火焼鳥たくちゃん"}>
      <div className="flex flex-col gap-3 pb-6">
        <Link
          to="/reservation/new"
          className="block rounded-lg bg-neutral-900 px-4 py-3 text-center text-sm font-semibold text-white"
        >
          ご予約はこちら
        </Link>
        <Link
          to="/reservations"
          className="block rounded-lg border border-neutral-300 px-4 py-3 text-center text-sm font-semibold"
        >
          予約の確認・キャンセル
        </Link>
        {isOwner ? (
          <Link
            to="/admin"
            className="block rounded-lg border-2 border-amber-500 bg-amber-50 px-4 py-3 text-center text-sm font-semibold text-amber-700"
          >
            管理メニュー
          </Link>
        ) : null}
      </div>

      <section className="rounded-lg border border-neutral-200 bg-white p-4">
        <h2 className="mb-3 text-sm font-semibold">店舗情報</h2>
        <dl className="flex flex-col gap-3 text-sm">
          {businessHours ? <Row label="営業時間" value={businessHours} /> : null}
          {shop?.address ? <Row label="住所" value={shop.address} /> : null}
          {shop?.phone ? (
            <Row
              label="電話"
              value={
                <a className="text-blue-600 underline" href={`tel:${shop.phone.replace(/-/g, "")}`}>
                  {shop.phone}
                </a>
              }
            />
          ) : null}
          <Row
            label="Instagram"
            value={
              <a
                className="text-blue-600 underline"
                href="https://www.instagram.com/takuchan_yakitori/"
                target="_blank"
                rel="noreferrer"
              >
                @takuchan_yakitori
              </a>
            }
          />
        </dl>
      </section>
    </PageLayout>
  );
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex gap-3">
      <dt className="w-20 shrink-0 text-xs text-neutral-500">{label}</dt>
      <dd className="flex-1 text-sm">{value}</dd>
    </div>
  );
}

function formatBusinessHours(bh: unknown): string | null {
  if (!Array.isArray(bh) || bh.length === 0) return null;
  const sample = bh[0] as { open?: string; close?: string };
  const allSame = bh.every(
    (h) =>
      (h as { open?: string; close?: string }).open === sample.open &&
      (h as { open?: string; close?: string }).close === sample.close,
  );
  if (allSame && sample.open && sample.close) {
    return `毎日 ${sample.open}〜${sample.close}`;
  }
  return null;
}
